const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const LocalizationManagementCommand: any = {
    GetLocalizationManagementListByFilter: Backofficebff + '/v1/localizationmanager/list',
    DeleteLocalizationManagement: Backofficebff + '/v1/localizationmanager/clear',
    UpdateLocalizationManagement: Backofficebff + '/v1/localizationmanager/update',
    AddLocalizationManagement: Backofficebff + '/v1/localizationmanager/add',
};
